import BaseRepositoryService from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import { CustomMessageTagValidation } from 'uplisting-frontend/validations';

export default class CustomMessageTagRepositoryService extends BaseRepositoryService<
  ModelRegistry['custom-message-tag']
> {
  recordName = 'custom-message-tag';
  implementMethods = [
    'findAll',
    'buildChangeset',
    'createRecord',
    'unloadAll',
    'peekAll',
  ];

  validation = CustomMessageTagValidation;
}

declare module '@ember/service' {
  interface Registry {
    'repositories/custom-message-tag': CustomMessageTagRepositoryService;
  }
}
